Date.prototype.toArangoDate = function () {
  return +`${this.getFullYear()}${getMonthWithLeadingZero(this)}`;
};

Date.fromArangoDate = (value?: number) => {
  if (!value) return new Date();

  // -1 Because for JS Date, month start at 1, and not 0, meaning 11 is considered December..
  const month = +value.toString().substring(4) - 1;
  const year = +value.toString().substring(0, 4);
  return new Date(year, month);
};

function getMonthWithLeadingZero(date: Date): string {
  return (date.getMonth() + 1).toString().padStart(2, '0');
}
